import React from 'react';
import styles from './BamDatabaseView.module.css';

const BamDatabaseView: React.FC = () => {
  const navigateTo = (hash: string) => {
    window.location.hash = hash;
  };

  return (
    <section className={styles.root}>
      <header className={styles.header}>
        <h2 className={styles.title}>BAM Database - Home</h2>
        <p className={styles.subtitle}>
          Choose the workflow or dataset you want to explore. Each module launches a dedicated experience tailored to the
          BAM quality and discovery pipeline.
        </p>
      </header>

      <div className={styles.grid}>
        <article className={styles.panel}>
          <h3 className={styles.panelTitle}>A Search &amp; Discovery</h3>
          <p className={styles.panelText}>
            Surface award programs, categories, and related insights through guided search tools and curated discovery
            paths.
          </p>
          <button
            type="button"
            className={`${styles.actionButton} ${styles.discoveryButton}`}
            onClick={() => navigateTo('#search-discover')}
          >
            Search &amp; Discovery
          </button>
        </article>

        <article className={styles.panel}>
          <h3 className={styles.panelTitle}>B Quality Validation</h3>
          <p className={styles.panelText}>
            Validate timelines, eligibility, and fee data before publishing. Review enrichment notes and flag follow-up
            actions for the team.
          </p>
          <button
            type="button"
            className={`${styles.actionButton} ${styles.validationButton}`}
            onClick={() => navigateTo('#quality-check')}
          >
            Quality Check
          </button>
        </article>

        <article className={styles.panel}>
          <h3 className={styles.panelTitle}>C Programs &amp; Categories</h3>
          <p className={styles.panelText}>
            Browse award programs, validate timelines, and cross-reference category coverage as part of the shared data
            backbone.
          </p>
          <div className={styles.buttonGroup}>
            <button
              type="button"
              className={`${styles.actionButton} ${styles.programButton}`}
              onClick={() => navigateTo('#data-quality')}
            >
              Programs
            </button>
            <button
              type="button"
              className={`${styles.actionButton} ${styles.categoryButton}`}
              onClick={() => navigateTo('#categories-quality')}
            >
              Categories
            </button>
          </div>
        </article>
      </div>
    </section>
  );
};

export default BamDatabaseView;
